import getRole from '../auth/getRole'

export default defineNuxtRouteMiddleware((to, from) => {
    if (to.path === '/') {
      return navigateTo('/start')
    }
    if (to.path === '/section/jiudian') {
        if(getRole().includes('酒店')){
            return navigateTo('/jiudian/ydsjtb')
        }
    }
    if (to.path === '/start') {
        if(getRole().includes('酒店')){
            return navigateTo('/jiudian/ydsjtb')
        }
    }
  })